export default "__VITE_ASSET__DpNPOIss__"